import React from 'react'

function FaqPage() {
  return (
    <div>FaqPage</div>
  )
}

export default FaqPage